import { merge } from 'lodash';
import { getContext } from '@fiverr-private/fiverr_context';
import { mixpanel, bigQuery } from '@fiverr-private/obs';

export const EVENT_NAMES = {
    VIEWED: 'Seller portfolio - Viewed',
    GRID_CLICK: 'Seller Portfolio - project clicked',
    ARROW_CLICK: 'Seller Portfolio - arrow clicked',
    CONTACT_ME: 'Seller Portfolio - Contact seller clicked',
    BI_COMPONENT_VIEWED: 'seller_portfolio_component_exists',
    BI_PROJECT_SHOW: 'project_show',
    BI_CONTACT_ME: 'clicked_on_contact_seller_in_seller_portfolio',
    BI_PORTFOLIO_PROJECT_CLICK: 'click_on_portfolio_project',
    ADD_PROJECT_CLICK: 'clicked_on_add_project',
    SEE_PROJECTS_CLICK: 'clicked_on_view_see_projects'
};

const findProjectById = (list, id) => list.find((project) => project.id === id);
const baseBQData = (seller, origin, gigId) => {
    const { userId, pageCtxId } = getContext();
    const { username, id } = seller;

    const bqData = {
        user: {
            id: userId
        },
        group: 'seller_portfolio',
        sub_group: 'seller_portfolio',
        entity: 'client',
        page: {
            ctx_id: pageCtxId,
            name: origin
        },
        seller: {
            id,
            username
        }
    };

    if (gigId) {
        bqData.gig = { id: gigId };
    }

    return bqData;
};
const baseMPData = (seller, origin) => {
    const { userId, userGuid } = getContext();
    const { username, id, is_pro, achievement } = seller;

    return {
        'UserId': userId,
        'UserGuid': userGuid,
        'Navigation Source': origin,
        'Page Name': origin,
        'Seller Name': username,
        'Seller Id': id,
        'Pro Seller': is_pro,
        'Seller Level': achievement
    };
};

export const events = {
    addProjectClick: (seller, origin) => {
        mixpanel.track(EVENT_NAMES.ADD_PROJECT_CLICK, baseMPData(seller, origin));

        bigQuery.send(merge(
            baseBQData(seller, origin),
            {
                type: EVENT_NAMES.ADD_PROJECT_CLICK,
                event_source: 'seller_page'
            }
        ));
    },
    seeProjectsClick: (seller, origin) => {
        mixpanel.track(EVENT_NAMES.SEE_PROJECTS_CLICK, baseMPData(seller, origin));

        bigQuery.send(merge(
            baseBQData(seller, origin),
            {
                type: EVENT_NAMES.SEE_PROJECTS_CLICK,
                event_source: 'seller_page'
            }
        ));
    },
    componentViewed: (projectsShown, seller, origin, gigId) => {
        mixpanel.track(EVENT_NAMES.VIEWED, baseMPData(seller, origin));

        bigQuery.send(merge(
            baseBQData(seller, origin, gigId),
            {
                type: EVENT_NAMES.BI_COMPONENT_VIEWED,
                page: {
                    element: {
                        name: 'number_of_seller_projects_that_shown',
                        metadata: projectsShown
                    }
                }
            }
        ));
    },
    projectClick: ({ projectId, mixpanelEvent, biEvent, seller, origin, projectList }) => {
        const project = findProjectById(projectList, projectId);

        mixpanel.track(mixpanelEvent, merge(
            baseMPData(seller, origin),
            {
                'Project name': project?.title
            }
        ));

        if (biEvent) {
            bigQuery.send({
                ...baseBQData(seller, origin),
                type: biEvent
            });
        }
    },
    projectShow: (projectData, seller, origin, projectList, gigId) => {
        const { sub_category_id } = projectData;

        bigQuery.send(merge(
            baseBQData(seller, origin, gigId),
            {
                type: EVENT_NAMES.BI_PROJECT_SHOW,
                event_source: 'seller_portfolio_grid',
                seller: {
                    portfolio_project: {
                        project_id: projectData.project_id,
                        sub_category_id,
                        has_link: false
                    }
                },
                page: {
                    element: {
                        name: 'number_of_seller_projects_that_shown',
                        metadata: projectList.length,
                        position: projectList.indexOf(findProjectById(projectList, projectData.project_id)) + 1
                    }
                }
            }
        ));
    },
    contactMeClick: (projectId, projectData, seller, origin, gigId) => {
        const { sub_category_id, title } = projectData;

        mixpanel.track(EVENT_NAMES.CONTACT_ME, merge(
            baseMPData(seller, origin),
            {
                'Project name': title
            }
        ));

        bigQuery.send(merge(
            baseBQData(seller, origin, gigId),
            {
                type: EVENT_NAMES.BI_CONTACT_ME,
                event_source: 'seller_portfolio_modal',
                seller: {
                    portfolio_project: {
                        project_id: projectId,
                        sub_category_id,
                        has_link: false
                    }
                }
            }
        ));
    }
};
